<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          title="Sales Collection Report"
      />
    </div>

    <div class="col-12 pt-2">
      <div class="px-2">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <button
                class="nav-link"
                :class="{ active: activeTab === 'invoice' }"
                @click="switchTab('invoice')"
                type="button"
            >Invoice Wise</button>
          </li>
          <li class="nav-item">
            <button
                class="nav-link"
                :class="{ active: activeTab === 'date' }"
                @click="switchTab('date')"
                type="button"
            >Date Wise</button>
          </li>
          <li class="nav-item">
            <button
                class="nav-link"
                :class="{ active: activeTab === 'user' }"
                @click="switchTab('user')"
                type="button"
            >User Wise</button>
          </li>
        </ul>

        <div class="tab-content">
          <InvoiceWiseTable v-if="activeTab === 'invoice'" />
          <DateWiseTable    v-if="activeTab === 'date'" />
          <UserWiseTable    v-if="activeTab === 'user'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import TitleButton from '@/components/atom/TitleButton';
import InvoiceWiseTable from '@/components/atom/super-shop/sales-collection-report/InvoiceWiseTable.vue';
import DateWiseTable from '@/components/atom/super-shop/sales-collection-report/DateWiseTable.vue';
import UserWiseTable from '@/components/atom/super-shop/sales-collection-report/UserWiseTable.vue';

const router = useRouter();
const route  = useRoute();

const validTabs = ['invoice', 'date', 'user'];
const initialTab = validTabs.includes(route.query.tab) ? route.query.tab : 'invoice';
const activeTab = ref(initialTab);

const switchTab = async (tab) => {
  if (activeTab.value === tab) return;
  activeTab.value = tab;
  let routeQuery = Object.assign({}, route.query, { tab });
  delete routeQuery.page;
  await router.push({ path: route.path, query: routeQuery });
};
</script>
